import { registerWidget } from "dmeditor";
import definition from "./definition";
import { Line } from "./Line";

export default () => {
  registerWidget(definition, { render: Line });
};
